export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--N.894b078c.png";